module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-route",
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10em",
      "margin-right": "1.6em"
    },
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "edit-switch-bar"
  }, [(_vm.seller_mode) ? _c('div', {
    staticClass: "col-md-3 col-sm-12",
    staticStyle: {
      "margin-bottom": "2em",
      "background": "rgba(247, 242, 241, 0.89)",
      "padding": "1em"
    }
  }, [(_vm.edit_mode) ? _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Editing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])]) : _c('span', {
    staticClass: "product-num"
  }, [_vm._v("You are in "), _c('u', [_vm._v("Viewing")]), _vm._v(" mode "), _c('button', {
    staticClass: "btn btn-xs btn-edit",
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Turn Off")])])]) : _vm._e(), _vm._v(" "), (_vm.seller_mode) ? _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.edit_mode) ? _c('button', {
    staticClass: "btn btn-xs",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Edit Gallery")]) : _c('button', {
    staticClass: "btn btn-xs",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": _vm.switchMode
    }
  }, [_vm._v("Done Editing")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [_c('h4', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.gallery.gallery_posts_group_name) + " Lookbook")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [_c('section', {
    staticClass: "padding-top-10 padding-bottom-10"
  }, [(!_vm.edit_mode) ? _c('div', {
    staticStyle: {
      "padding": "1em"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "background": "#262b30",
      "border": "#000000 solid 1em",
      "min-height": "50em"
    }
  }, [_c('div', {
    staticClass: "col-md-10 col-xs-8 gallery-left"
  }, [(_vm.display_post.gallery_post_media && (_vm.display_post.gallery_post_media.length > 0)) ? _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('img', {
    staticClass: "img-1 sp-prd-img",
    attrs: {
      "src": _vm.display_post.gallery_post_media[0].gallery_post_media,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('h6', [_vm._v(_vm._s(_vm.display_post.gallery_post_caption))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.display_post.gallery_post_details))])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.gallery.gallery_posts_group_text))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-4 gallery-right"
  }, _vm._l((_vm.gallery.gallery_posts_group_posts), function(post) {
    return _c('div', {
      staticClass: "post-folder"
    }, [(post.gallery_post_media && (post.gallery_post_media.length > 0)) ? _c('div', {
      staticClass: "img-wrap"
    }, [_c('img', {
      staticClass: "img-1 sp-prd-img",
      attrs: {
        "src": post.gallery_post_media[0].gallery_post_media,
        "alt": ""
      }
    })]) : _vm._e()])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {
    staticClass: "shop-detail"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card col-md-4 col-xs-12",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "2em"
    }
  }, [(_vm.editGalleryPanel) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('h6', [_vm._v("Edit Lookbook")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Name\r\n                                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_posts_group_name),
      expression: "gallery.gallery_posts_group_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.gallery.gallery_posts_group_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_posts_group_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Details\r\n                                        "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gallery.gallery_posts_group_text),
      expression: "gallery.gallery_posts_group_text"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.gallery.gallery_posts_group_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gallery.gallery_posts_group_text = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editGallery
    }
  }, [_vm._v("Save Lookbook")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])])]) : _c('div', [_c('button', {
    staticClass: "btn btn-xs pull-right",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('edit-gallery', '')
      }
    }
  }, [_vm._v("Edit Lookbook Details")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h6', [_c('b', [_vm._v("Lookbook Name: ")]), _vm._v(_vm._s(_vm.gallery.gallery_posts_group_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Details: ")]), _vm._v(_vm._s(_vm.gallery.gallery_posts_group_text))]), _vm._v(" "), (_vm.gallery.gallery_posts_group_type == 1) ? _c('p', [_c('b', [_vm._v("Type:")]), _vm._v(" Posts Only Lookbook")]) : _vm._e(), _vm._v(" "), (_vm.gallery.gallery_posts_group_type == 2) ? _c('p', [_c('b', [_vm._v("Type:")]), _vm._v(" Product/Service Lookbook")]) : _vm._e(), _vm._v(" "), _c('p', [_c('b', [_vm._v("Added On: ")]), _vm._v(_vm._s(_vm.gallery.gallery_posts_group_time_ago))]), _vm._v(" "), (_vm.gallery.gallery_posts_group_posts) ? _c('p', [_c('b', [_vm._v("No. of Posts: ")]), _vm._v(_vm._s(_vm.gallery.gallery_posts_group_posts.length))]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('remove-gallery', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete this Gallery")]), _vm._v(" "), (_vm.removeGalleryPanel) ? _c('span', {}, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to remove this Gallery?")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": _vm.removeGallery
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "card col-md-8 col-xs-12 padding-bottom-100",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('h6', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-weight": "bold"
    }
  }, [_vm._v("Posts in Lookbook")]), _vm._v(" "), (_vm.gallery.gallery_posts_group_type == 2) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Posts in this lookbook can ony be edited on their product page when viewed")]) : _vm._e(), _vm._v(" "), (_vm.viewGalleryPost) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "border": "dashed #cccccc"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [(!(_vm.display_post.gallery_post_product)) ? _c('button', {
    staticClass: "btn btn-xs pull-right",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('edit-gallery-post', '')
      }
    }
  }, [_vm._v("Edit Post")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs pull-right",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('close-view-gallery-post', '')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.editGalleryPostPanel) ? _c('div', {
    staticClass: "contact_form"
  }, [_c('h6', [_vm._v("Edit Lookbook")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Caption\r\n                                                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display_post.gallery_post_caption),
      expression: "display_post.gallery_post_caption"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.display_post.gallery_post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.display_post.gallery_post_caption = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Details\r\n                                                "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.display_post.gallery_post_details),
      expression: "display_post.gallery_post_details"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.display_post.gallery_post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.display_post.gallery_post_details = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editGalleryPost
    }
  }, [_vm._v("Save Post")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])])])]) : _c('div', [_c('h6', [_c('b', [_vm._v("Post Caption: ")]), _vm._v(_vm._s(_vm.display_post.gallery_post_caption))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Details: ")]), _vm._v(_vm._s(_vm.display_post.gallery_post_details))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Added On: ")]), _vm._v(_vm._s(_vm.display_post.gallery_post_time_ago))]), _vm._v(" "), (_vm.display_post.gallery_post_product && (_vm.display_post.gallery_post_product != 0)) ? _c('p', [_c('a', {
    staticClass: "btn btn-xs",
    attrs: {
      "href": '/' + _vm.gallery.gallery_posts_group_ownerusername + '/' + _vm.display_post.gallery_post_url_caption
    }
  }, [_vm._v("View Product/Service")])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding-left": "0"
    }
  }, [(_vm.removeGalleryPostPanel) ? _c('span', {}, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Do you really want to remove this Post?")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": _vm.removeGalleryPost
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])]) : _c('button', {
    staticClass: "btn pull-left",
    staticStyle: {
      "line-height": "2em"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('remove-gallery-post', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Delete this Post")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('h5', [_vm._v("Post Media ")]), _vm._v(" "), (_vm.display_post.gallery_post_media && (_vm.display_post.gallery_post_media.length > 0)) ? _c('div', {
    staticClass: "img-row"
  }, [_vm._l((_vm.display_post.gallery_post_media), function(pm) {
    return _c('div', {
      staticClass: "img-column"
    }, [(_vm.checkIfVideo(pm.gallery_post_media)) ? _c('div', [_c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    })]) : _c('div', [((pm.gallery_post_media && (pm.gallery_post_media != 'error'))) ? _c('img', {
      staticClass: "img-1 sp-prd-img",
      attrs: {
        "src": pm.gallery_post_media
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), (!(_vm.display_post.gallery_post_product)) ? _c('a', {
      staticClass: "btn pull-right",
      staticStyle: {
        "margin-top": "-3em",
        "font-size": "10px",
        "padding": "6px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deletePostImage(pm.gallery_post_media_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()])
  }), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Add new Media")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*,video/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange2($event, 'gallery_media', _vm.display_post.gallery_post_id)
      }
    }
  })])])])]) : _c('div', [_vm._l((_vm.gallery.gallery_posts_group_posts), function(post) {
    return _c('div', {
      staticClass: "post-folder col-md-2 col-xs-4"
    }, [(post.gallery_post_media && (post.gallery_post_media.length > 0)) ? _c('div', {
      staticClass: "img-wrap"
    }, [_c('img', {
      staticClass: "img-1 sp-prd-img",
      attrs: {
        "src": post.gallery_post_media[0].gallery_post_media,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('p', {
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(post.gallery_post_caption))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('view-gallery-post', post)
        }
      }
    }, [_vm._v("view post")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "1em"
    }
  }, [(_vm.addNewPost) ? _c('div', {
    staticClass: "cart-ship-info register col-sm-10 contact_form"
  }, [(_vm.gallery.gallery_posts_group_type == 2) ? _c('div', [_c('product-gallery-form')], 1) : _c('div', [_c('h6', [_vm._v("New Gallery Post")]), _vm._v(" "), _c('form', {
    staticClass: "sp-form-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v(" *Caption\r\n                                  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_caption),
      expression: "post.post_caption"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.post.post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_caption = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Details\r\n                                  "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_details),
      expression: "post.post_details"
    }],
    domProps: {
      "value": (_vm.post.post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_details = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn"
  }, [_vm._v("Add Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addPostToGallery
    }
  }, [_vm._v("Add")])])])])])]) : _c('button', {
    staticClass: "btn btn-xs",
    staticStyle: {
      "line-height": "0.8",
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('add-new-post', '')
      }
    }
  }, [_vm._v("Add New Post")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "2em"
    }
  }, [_c('section', {
    staticClass: "padding-top-50 padding-bottom-150"
  }, [_c('div', {}, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "heading text-center"
  }, [_c('h4', [_vm._v("ALSO IN MY GALLERY")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d8fb3ea"}!./src/pages/Sellpoint/Gallery/template.html
// module id = 273
// module chunks = 0